import { SelectChangeEvent } from '@mui/material';
import {
  usePartnerShortQuery,
  useProvidersShortQuery,
  useUpdateWorklistTablePreferencesMutation,
  useWorklistTablePreferencesQuery,
} from '@common/cache';
import { paths } from '@common/types';
import { useEffect, useState } from 'react';
import { debounce } from 'util/debounce.ts';
import { useMyWorklistFilterStore } from 'views/pages/Worklist/MyWorklist/store/filter.store.ts';
import { useMyWorklistStore } from '@store';

export const useFilters = () => {
  const { data: providerList = [] } = useProvidersShortQuery({});
  const { data: partnerData = [] } = usePartnerShortQuery();
  const {
    filters,
    setFilters: handleFilterChange,
    handleToggleFiltersCard,
    isFiltersCardOpen,
    appliedFiltersCount,
  } = useMyWorklistFilterStore();
  const { setProviderIds, setPartnerId } = useMyWorklistStore();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    debounce(
      () => {
        handleFilterChange({
          search: e.target.value,
        });
      },
      true,
      300,
    );
  };

  const handleOwnTasksOnlyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange({
      own_tasks_only: e.target.checked,
    });
  };

  const handlePartnerOnChange = (e: SelectChangeEvent<string>) => {
    handleFilterChange({
      partner_id: e.target.value,
    });
    setPartnerId(e.target.value);
  };

  const handleProviderOnChange = (newValues: string[]) => {
    handleFilterChange({
      provider_ids: newValues,
    });
    setProviderIds(newValues);
  };

  const partnerOptions =
    partnerData.map(partner => ({
      value: partner.id,
      label: partner.name,
    })) || [];

  const providerOptions =
    providerList.map(o => ({
      value: o.id,
      label: o.name,
    })) || [];

  const { data: preferences } = useWorklistTablePreferencesQuery();
  const updatePreferencesMutation = useUpdateWorklistTablePreferencesMutation();

  const handleUpdatePreferences = async (
    newPreferences: Partial<
      paths['/preferences/task-table']['patch']['requestBody']['content']['application/json']
    >,
  ) => {
    await updatePreferencesMutation.mutateAsync(newPreferences);
  };

  useEffect(() => {
    setSearchQuery(filters.search || '');
  }, [filters.search]);

  return {
    filters,
    handleSearchChange,
    handlePartnerOnChange,
    handleToggleFiltersCard,
    handleOwnTasksOnlyChange,
    handleProviderOnChange,
    partnerOptions,
    providerOptions,
    isFiltersCardOpen,
    appliedFiltersCount,
    handleUpdatePreferences,
    preferences,
    searchQuery,
  };
};
